import React, {useEffect} from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileBetterFood = ({
    clickNext = () => {},
    clickPrev = () => {},
    clicked
                            }) => {

  useEffect(() => {
    if (clicked) {
      clickNext("");
    }
  }, [clicked]);
  return (
    <div className="better-food-mobile" data-model-id="16761:1138">
      <div className="div">
        <p className="title">Learn to make better choices of food</p>

        <div className="content-container">
          <div className="left-card">
            <div className="calo-2">
              <div className="kcal-number">
                <div className="left-calories">475</div>

                <div className="left-cal">Cal</div>
              </div>

              <div className="div-2">
                <div className="text-wrapper">Calo's Recipe</div>

                <Image src="/static/image/questionnaire/weight-loss/betterFood/left-img.png" alt="Left img" className="left-img" />
              </div>
            </div>

            <div className="box">
              <div className="kcal-number">
                <div className="right-calories">1158</div>

                <div className="right-cal">Cal</div>
              </div>

              <div className="div-2">
                <div className="text-wrapper">Box Meal</div>

                <Image src="/static/image/questionnaire/weight-loss/betterFood/right img.png" alt="Rght img" className="rght-img" />
              </div>
            </div>
          </div>

          <a className="description" href={"https://cms-cache.foodscannerai.com/recipe/Calo_Source_of_Recommendation.html"}>Source of recommendations</a>
        </div>
      </div>

    </div>
  );
};
